import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';

export const UsersPageContainer = styled(Box).attrs({
  justify: 'start',
  position: 'relative',
})``;

export const Container = styled(Box).attrs(({ theme }) => ({
  justify: 'start',
  border: `1px solid ${theme.colors.heavyLineOutline}`,
  borderRadius: '5px',
  height: 430,
}))`
  overflow-x: hidden;
  overflow-y: auto;
`;

export const UsersTable = styled.div`
  display: block;
`;

export const UserTHead = styled.div`
  display: grid;
  border-collapse: collapse;
  min-width: 100%;
  grid-template-columns: 6.76% 19.96% 32.16% 13.36% 14.36% 13.36%;
  align-items: center;
  z-index: 1;
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.colors.background};
  z-index: 2;
`;

export const UserContent = styled.div`
  display: contents;
`;

export const UserTData = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: ${({ flexEnd }) => (flexEnd ? 'flex-end' : 'flex-start')};
  align-items: center;
  padding: 5px 10px;
  font-weight: 700;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.primaryText};
  background-color: ${({ theme }) => theme.colors.background};
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'unset')};
`;

export const CheckBoxWrapper = styled(Box).attrs(() => ({
  width: 22,
  height: 22,
  borderRadius: '5px',
}))`
  cursor: pointer;
`;

export const AddButtonContainer = styled(Box).attrs(() => ({
  pt: 2,
  pb: 3,
  justify: 'space-between',
  align: 'center',
}))``;

export const IconWrapper = styled(Box).attrs(() => ({
  p: 2,
  borderRadius: '5px',
  color: 'secondaryLink',
}))`
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'unset')};
  opacity: ${({ clickable }) => (clickable ? 1 : 0.3)};
  padding-right: ${({ lastIcon }) => (lastIcon ? 0 : '8px')};
  &:hover {
    background-color: ${({ theme, clickable }) =>
      clickable ? theme.colors.lightLineDivider : 'unset'};
  }
  @media (max-width: ${BP_LAPTOP}px) {
    padding: 8px 0;
  }
`;

export const TooltipChild = styled(Box).attrs(() => ({
  position: 'absolute',
  color: 'background',
  bg: 'primaryText',
  borderRadius: '5px',
  p: '10px',
}))`
  display: none;
  white-space: nowrap;
  right: 0;
  top: 110%;
`;

export const CustomToolTip = styled(Box).attrs(() => ({
  position: 'relative',
}))`
  &:hover ${TooltipChild} {
    display: ${p => (p.isVisible ? 'flex' : 'none')};
  }
`;
